import { render, staticRenderFns } from "./SharedTipsLine.vue?vue&type=template&id=48fd9d6b&scoped=true&"
import script from "./SharedTipsLine.vue?vue&type=script&lang=js&"
export * from "./SharedTipsLine.vue?vue&type=script&lang=js&"
import style0 from "./SharedTipsLine.vue?vue&type=style&index=0&id=48fd9d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fd9d6b",
  null
  
)

export default component.exports